import { useState } from "react"
import { Input } from "antd"
import { MdExpandMore } from "react-icons/md"
import Dropdown from "../../Common/DropDown"
import { getSortedLanguages } from "../../../constants/languages"

// Optional Voice Profile: Language (searchable, custom entries allowed) and Accent (free text).
// Saved on the one Character record; AI uses them with Gender and Age for spoken dialogue
// (Dialogue, V.O. and O.S./O.C.). Tone and emotion still come from the screenplay itself.
export default function VoiceProfileFields({ character, onChange, disabled = false, compact = false }) {
    const [open, setOpen] = useState(Boolean(character?.language || character?.accent))
    const [search, setSearch] = useState("")
    const languages = getSortedLanguages().map(([, name]) => name)
    const matches = languages.filter((name) => name.toLowerCase().includes(search.toLowerCase()))
    const custom = search.trim() && !languages.some((name) => name.toLowerCase() === search.trim().toLowerCase()) ? search.trim() : null
    const text = compact ? "text-[12px]" : "text-[14px]"

    return <div className="mb-2">
        <button type="button" onClick={() => setOpen(!open)}
            className={`flex w-full items-center justify-between border border-[#CACACA] rounded-lg px-3 py-2 ${text} text-[#868686]`}>
            Voice Profile
            <MdExpandMore size={18} color="#CACACA" style={{ transform: open ? "rotate(180deg)" : "none" }} />
        </button>
        {open && <div className={`mt-2 ${text}`}>
            <label className="text-gray-500">Language</label>
            {disabled ? <p className="mt-1 mb-2">{character?.language || "—"}</p> : <Dropdown close={character?.language} className="w-full mt-2 mb-2" alignment="left" trigger={
                <button type="button" className="bg-white hover:bg-[#efefef] text-start rounded-lg flex items-center justify-between border border-[#CACACA] px-3 py-2 w-full">
                    {character?.language || "Select language"}
                    <MdExpandMore size={18} color="#CACACA" />
                </button>}>
                <div className="flex w-[220px] flex-col gap-1 max-h-[260px] overflow-y-auto p-1">
                    <input aria-label="Search language" className="p-2 w-full border-[#CACACA] border rounded-md" placeholder="Search or add language"
                        onChange={(e) => setSearch(e.target.value)} value={search} />
                    {custom && <button type="button" onClick={() => { onChange("language", custom); setSearch("") }}
                        className="w-full border-b text-start px-3 py-2 hover:bg-[#e2e2e2] text-[#0099ff]">
                        Add "{custom}"
                    </button>}
                    {matches.map((name) => (
                        <button type="button" key={name} onClick={() => { onChange("language", name); setSearch("") }}
                            style={{ color: character?.language === name ? "#0099ff" : "#868686", background: character?.language === name ? "#f0f9ff" : "" }}
                            className="w-full border-b text-start px-3 py-2 hover:bg-[#e2e2e2]">
                            {name}
                        </button>
                    ))}
                </div>
            </Dropdown>}
            <label className="text-gray-500">Accent</label>
            <Input aria-label="Accent" className="mt-2 w-full" size={compact ? "middle" : "large"} disabled={disabled}
                placeholder="e.g. Scottish, Southern American"
                value={character?.accent || ""} onChange={(e) => onChange("accent", e.target.value)} />
        </div>}
    </div>
}
